// Translation system for mokiplaner
// Supported languages: de (German), en (English)

export const translations = {
  de: {
    // Navigation
    nav: {
      home: "Startseite",
      pricing: "Preise",
      features: "Features",
      about: "Über uns",
      contact: "Kontakt",
      login: "Anmelden",
      logout: "Abmelden",
      dashboard: "Dashboard",
      admin: "Admin",
    },
    
    // Hero Section
    hero: {
      slogan: "Der perfekte Moment – digital geplant.",
      subtitle: "Erstelle wunderschöne digitale Events für Hochzeiten, Geburtstage und besondere Anlässe. Alles an einem Ort – einfach, schön und unvergesslich.",
      cta: "Jetzt starten",
      learnMore: "Mehr erfahren",
    },
    
    // Features
    features: {
      title: "Alles was du brauchst",
      subtitle: "Plane dein perfektes Event mit unseren umfangreichen Features",
      
      // Feature names
      guestbook: "Gästebuch",
      timeline: "Zeitleiste",
      gallery: "Galerie",
      music_upload: "Musik hochladen",
      music_requests: "Musikwünsche",
      polls: "Umfragen",
      rsvp: "RSVP / Zusagen",
      gift_registry: "Geschenkliste",
      menu_card: "Menükarte",
      seating_plan: "Sitzplan",
      budget_tracker: "Budget-Tracker",
      gift_budget_split: "Geschenk-Budget aufteilen",
      custom_domain: "Eigene Domain",
      analytics: "Statistiken",
      email_notifications: "E-Mail Benachrichtigungen",
      sms_notifications: "SMS Benachrichtigungen",
      custom_branding: "Eigenes Branding",
      api_access: "API Zugriff",
      guest_list: "Gästeliste",
      service_providers: "Dienstleister",
      wishlist: "Wunschliste",
      tips: "Tipps",
      witnesses: "Trauzeugen",
      dresscode: "Dresscode",
      hotel_recommendations: "Hotel-Empfehlungen",
      childcare: "Kinderbetreuung",
      carpool: "Fahrgemeinschaften",
      task_list: "Aufgabenliste",
      shopping_list: "Einkaufsliste",
      selfie_game: "Selfie-Spiel",
      parking: "Parken",
      thank_you_message: "Dankesnachricht",
      digital_yearbook: "Digitales Jahrbuch",
      video_header: "Video-Header",
      helper_roles: "Helfer-Rollen",
      timeline_visual: "Visuelle Timeline",
      congratulation_video: "Glückwunsch-Video",
      memory_box: "Erinnerungs-Box",
      career_path: "Karriereweg",
    },
    
    // Pricing
    pricing: {
      title: "Wähle dein Paket",
      subtitle: "Alle Pakete - Kompakt und übersichtlich. Fahre mit der Maus über Features für Details.",
      comparison: "Feature-Vergleich",
      comparisonSubtitle: "Alle Features im Überblick - finde das perfekte Paket für deine Bedürfnisse",
      perMonth: "/Monat",
      free: "Kostenlos",
      startNow: "Jetzt starten",
      recommended: "Empfohlen",
      maxEvents: "Max. Events",
      maxParticipants: "Max. Teilnehmer pro Event",
      testPeriod: "Testzeitraum",
      price: "Preis",
      days: "Tage",
      unlimited: "Unbegrenzt",
    },
    
    // Dashboard
    dashboard: {
      welcome: "Willkommen zurück",
      myEvents: "Deine Events",
      createEvent: "Neu",
      nextSteps: "Nächste Schritte",
      completedSteps: "abgeschlossen",
      quickStats: "Übersicht",
      upcomingEvents: "Kommende Events",
      totalGuests: "Gäste gesamt",
      daysUntil: "Tage bis",
    },
    
    // Onboarding
    onboarding: {
      welcomeTitle: "Willkommen bei mokiplaner! 🎉",
      step: "Schritt",
      of: "von",
      skip: "Tour überspringen",
      next: "Weiter",
      back: "Zurück",
      finish: "Los geht's!",
      
      step1Title: "Willkommen bei mokiplaner! 🎉",
      step1Subtitle: "Lass uns gemeinsam dein perfektes Event planen",
      step1Question: "Welche Art Event planst du?",
      
      step2Title: "Erzähl uns von deinem Event",
      step2Subtitle: "Diese Infos helfen uns, dich besser zu unterstützen",
      
      step3Title: "Entdecke die Features",
      step3Subtitle: "Das sind deine wichtigsten Tools",
      
      step4Title: "Bereit zum Start!",
      step4Subtitle: "Alles bereit! Zeit, dein Event zu erstellen",
    },
    
    // Event Types
    eventTypes: {
      wedding: "Hochzeit",
      birthday: "Geburtstag",
      party: "Party",
      bachelorette: "Junggesellenabschied",
      graduation: "Abschluss",
      anniversary: "Jubiläum",
      baby_shower: "Babyparty",
      corporate: "Firmenevent",
      christmas: "Weihnachten",
      new_year: "Silvester",
      easter: "Ostern",
      valentine: "Valentinstag",
      other: "Sonstiges",
    },
    
    // Footer
    footer: {
      slogan: "Der perfekte Moment – digital geplant.",
      imprint: "Impressum",
      privacy: "Datenschutz",
      contact: "Kontakt",
      allRightsReserved: "Alle Rechte vorbehalten.",
    },
    
    // Common
    common: {
      save: "Speichern",
      cancel: "Abbrechen",
      delete: "Löschen",
      edit: "Bearbeiten",
      add: "Hinzufügen",
      remove: "Entfernen",
      confirm: "Bestätigen",
      loading: "Lädt...",
      error: "Fehler",
      success: "Erfolg",
      warning: "Warnung",
      info: "Info",
      back: "Zurück",
      next: "Weiter",
      close: "Schließen",
      search: "Suchen",
    },
    
    // Create Event
    createEvent: {
      title: "Neues Event erstellen",
      eventName: "Event Name",
      eventNamePlaceholder: "z.B. Unsere Hochzeit",
      eventType: "Event-Typ",
      selectEventType: "Wähle einen Event-Typ",
      date: "Datum",
      location: "Ort",
      locationPlaceholder: "z.B. Schloss Neuschwanstein",
      description: "Beschreibung",
      descriptionPlaceholder: "Beschreibe dein Event...",
      createButton: "Event erstellen",
      creating: "Erstelle Event...",
    },
    
    // Event Detail
    eventDetail: {
      overview: "Übersicht",
      features: "Features",
      guests: "Gäste",
      settings: "Einstellungen",
      shareEvent: "Event teilen",
      copyLink: "Link kopieren",
      shareViaEmail: "Per E-Mail teilen",
      shareViaWhatsApp: "Per WhatsApp teilen",
      countdown: "Countdown",
      days: "Tage",
      hours: "Std",
      minutes: "Min",
      description: "Beschreibung",
      schedule: "Ablaufplan",
      addSchedule: "Ablauf hinzufügen",
      time: "Uhrzeit",
      activity: "Aktivität",
      serviceProviders: "Dienstleister",
      addProvider: "Dienstleister hinzufügen",
      providerName: "Name",
      providerCategory: "Kategorie",
      providerWebsite: "Website",
      providerPhone: "Telefon",
      guestList: "Gästeliste",
      addGuest: "Gast hinzufügen",
      guestName: "Name",
      guestEmail: "E-Mail",
      guestPhone: "Telefon",
      plusOne: "Begleitpersonen",
      confirmed: "Zugesagt",
      pending: "Ausstehend",
      declined: "Abgesagt",
      total: "Gesamt",
      eventType: "Event-Art",
      changeEventType: "Event-Art ändern",
      exportCalendar: "Als ICS exportieren",
      noSchedule: "Noch kein Ablauf definiert",
      noProviders: "Noch keine Dienstleister",
      noGuests: "Noch keine Gäste",
    },
    
    // Profile
    profile: {
      title: "Mein Profil",
      personalInfo: "Persönliche Informationen",
      name: "Name",
      email: "E-Mail",
      phone: "Telefon",
      currentPackage: "Aktuelles Paket",
      upgradePackage: "Paket upgraden",
      changePackage: "Paket wechseln",
      accountSettings: "Account-Einstellungen",
      deleteAccount: "Account löschen",
      logout: "Abmelden",
    },
  },
  
  en: {
    // Navigation
    nav: {
      home: "Home",
      pricing: "Pricing",
      features: "Features",
      about: "About",
      contact: "Contact",
      login: "Login",
      logout: "Logout",
      dashboard: "Dashboard",
      admin: "Admin",
    },
    
    // Hero Section
    hero: {
      slogan: "The perfect moment – digitally planned.",
      subtitle: "Create beautiful digital events for weddings, birthdays, and special occasions. Everything in one place – simple, beautiful, and unforgettable.",
      cta: "Get Started",
      learnMore: "Learn More",
    },
    
    // Features
    features: {
      title: "Everything you need",
      subtitle: "Plan your perfect event with our comprehensive features",
      
      // Feature names
      guestbook: "Guestbook",
      timeline: "Timeline",
      gallery: "Gallery",
      music_upload: "Music Upload",
      music_requests: "Music Requests",
      polls: "Polls",
      rsvp: "RSVP",
      gift_registry: "Gift Registry",
      menu_card: "Menu Card",
      seating_plan: "Seating Plan",
      budget_tracker: "Budget Tracker",
      gift_budget_split: "Gift Budget Split",
      custom_domain: "Custom Domain",
      analytics: "Analytics",
      email_notifications: "Email Notifications",
      sms_notifications: "SMS Notifications",
      custom_branding: "Custom Branding",
      api_access: "API Access",
      guest_list: "Guest List",
      service_providers: "Service Providers",
      wishlist: "Wishlist",
      tips: "Tips",
      witnesses: "Witnesses",
      dresscode: "Dresscode",
      hotel_recommendations: "Hotel Recommendations",
      childcare: "Childcare",
      carpool: "Carpool",
      task_list: "Task List",
      shopping_list: "Shopping List",
      selfie_game: "Selfie Game",
      parking: "Parking",
      thank_you_message: "Thank You Message",
      digital_yearbook: "Digital Yearbook",
      video_header: "Video Header",
      helper_roles: "Helper Roles",
      timeline_visual: "Visual Timeline",
      congratulation_video: "Congratulation Video",
      memory_box: "Memory Box",
      career_path: "Career Path",
    },
    
    // Pricing
    pricing: {
      title: "Choose Your Package",
      subtitle: "All packages - Compact and clear. Hover over features for details.",
      comparison: "Feature Comparison",
      comparisonSubtitle: "All features at a glance - find the perfect package for your needs",
      perMonth: "/month",
      free: "Free",
      startNow: "Start Now",
      recommended: "Recommended",
      maxEvents: "Max. Events",
      maxParticipants: "Max. Participants per Event",
      testPeriod: "Test Period",
      price: "Price",
      days: "Days",
      unlimited: "Unlimited",
    },
    
    // Dashboard
    dashboard: {
      welcome: "Welcome back",
      myEvents: "Your Events",
      createEvent: "New",
      nextSteps: "Next Steps",
      completedSteps: "completed",
      quickStats: "Overview",
      upcomingEvents: "Upcoming Events",
      totalGuests: "Total Guests",
      daysUntil: "Days until",
    },
    
    // Onboarding
    onboarding: {
      welcomeTitle: "Welcome to mokiplaner! 🎉",
      step: "Step",
      of: "of",
      skip: "Skip Tour",
      next: "Next",
      back: "Back",
      finish: "Let's Go!",
      
      step1Title: "Welcome to mokiplaner! 🎉",
      step1Subtitle: "Let's plan your perfect event together",
      step1Question: "What type of event are you planning?",
      
      step2Title: "Tell us about your event",
      step2Subtitle: "This information helps us support you better",
      
      step3Title: "Discover the Features",
      step3Subtitle: "These are your most important tools",
      
      step4Title: "Ready to Start!",
      step4Subtitle: "All set! Time to create your event",
    },
    
    // Event Types
    eventTypes: {
      wedding: "Wedding",
      birthday: "Birthday",
      party: "Party",
      bachelorette: "Bachelorette Party",
      graduation: "Graduation",
      anniversary: "Anniversary",
      baby_shower: "Baby Shower",
      corporate: "Corporate Event",
      christmas: "Christmas",
      new_year: "New Year",
      easter: "Easter",
      valentine: "Valentine's Day",
      other: "Other",
    },
    
    // Footer
    footer: {
      slogan: "The perfect moment – digitally planned.",
      imprint: "Imprint",
      privacy: "Privacy Policy",
      contact: "Contact",
      allRightsReserved: "All rights reserved.",
    },
    
    // Common
    common: {
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      add: "Add",
      remove: "Remove",
      confirm: "Confirm",
      loading: "Loading...",
      error: "Error",
      success: "Success",
      warning: "Warning",
      info: "Info",
      back: "Back",
      next: "Next",
      close: "Close",
      search: "Search",
    },
    
    // Create Event
    createEvent: {
      title: "Create New Event",
      eventName: "Event Name",
      eventNamePlaceholder: "e.g. Our Wedding",
      eventType: "Event Type",
      selectEventType: "Select an event type",
      date: "Date",
      location: "Location",
      locationPlaceholder: "e.g. Neuschwanstein Castle",
      description: "Description",
      descriptionPlaceholder: "Describe your event...",
      createButton: "Create Event",
      creating: "Creating Event...",
    },
    
    // Event Detail
    eventDetail: {
      overview: "Overview",
      features: "Features",
      guests: "Guests",
      settings: "Settings",
      shareEvent: "Share Event",
      copyLink: "Copy Link",
      shareViaEmail: "Share via Email",
      shareViaWhatsApp: "Share via WhatsApp",
      countdown: "Countdown",
      days: "Days",
      hours: "Hrs",
      minutes: "Min",
      description: "Description",
      schedule: "Schedule",
      addSchedule: "Add Schedule Item",
      time: "Time",
      activity: "Activity",
      serviceProviders: "Service Providers",
      addProvider: "Add Provider",
      providerName: "Name",
      providerCategory: "Category",
      providerWebsite: "Website",
      providerPhone: "Phone",
      guestList: "Guest List",
      addGuest: "Add Guest",
      guestName: "Name",
      guestEmail: "Email",
      guestPhone: "Phone",
      plusOne: "Plus One",
      confirmed: "Confirmed",
      pending: "Pending",
      declined: "Declined",
      total: "Total",
      eventType: "Event Type",
      changeEventType: "Change Event Type",
      exportCalendar: "Export as ICS",
      noSchedule: "No schedule defined yet",
      noProviders: "No providers yet",
      noGuests: "No guests yet",
    },
    
    // Profile
    profile: {
      title: "My Profile",
      personalInfo: "Personal Information",
      name: "Name",
      email: "Email",
      phone: "Phone",
      currentPackage: "Current Package",
      upgradePackage: "Upgrade Package",
      changePackage: "Change Package",
      accountSettings: "Account Settings",
      deleteAccount: "Delete Account",
      logout: "Logout",
    },
  },
};

// Get translation
export const t = (key, lang = 'de') => {
  const keys = key.split('.');
  let value = translations[lang];
  
  for (const k of keys) {
    if (value && value[k]) {
      value = value[k];
    } else {
      return key; // Return key if translation not found
    }
  }
  
  return value;
};
